import { Component, Input, Output, EventEmitter, signal, input, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DatePipe } from "@angular/common";
import { CurrencyPipe } from "@angular/common";
import { Account } from "../../entity/Account";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { User } from "../../entity/User";
import { AbstractComponent } from "../abstract/abstract.component";
import { IConsumptionDialog } from "./i-dialog-consumption.component";
import { first } from "rxjs/internal/operators/first";
import { ConsumptionDataType } from "../../obj/ConsumptionDataType";

@Component({
    selector: "kilowant-user-home-ai-subscription",
    templateUrl: "../../../html/incs/user-home-ai-subscription.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class UserHomeAISubscriptionComponent extends AbstractComponent {
    // Readonly inputs as signals
    client = input<User | null>(null);
    account = input<Account | null>(null);
    step = input<number>(0);
    selectMode = input<boolean>(false);
    previewMode = input<boolean>(false);
    consumptionDataType = input<ConsumptionDataType | null>(null);

    // Outputs remain EventEmitters
    @Output() returned = new EventEmitter<boolean>();
    @Output() changed = new EventEmitter<number>();

    // Internal writable signal for the selected level, synced with the nextContractLevel input
    protected nextContractLevel = signal<number>(0);

    // Setter to keep the signal in sync with the parent input
    @Input() set level(value: number) {
        this.nextContractLevel.set(value);
    }

    iConsumptionDialogRef: MatDialogRef<IConsumptionDialog> = null!;

    constructor(
        router: Router,
        route: ActivatedRoute,
        dialog: MatDialog,
        protected datepipe: DatePipe,
        protected currencypipe: CurrencyPipe,
        protected authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService
    ) { super(router, route, dialog, analyticsService, generalService); }

    ngOnInit(): void {
        super.ngOnInit();
    }

    pageStart(): void {
    }

    ngOnDestroy() {
    }

    ngAfterContentInit(): void {
    }

    back(): void {
        this.returned.emit(true);
    }

    switchMode(pos: number): void {
        if (this.nextContractLevel() === pos && this.selectMode()) {
            return;
        }
        if (this.consumptionDataType() !== ConsumptionDataType.FULL && pos > 1) {
            this.openConsumptionDialog();
            return;
        }
        this.nextContractLevel.set(pos);
        this.changed.emit(this.nextContractLevel());
        if (!this.selectMode()) {
            this.back();
        }
    }

    openConsumptionDialog(): void {
        this.iConsumptionDialogRef = this.dialog.open(IConsumptionDialog, {
            disableClose: false,
            panelClass: "i-icon-popup"
        });
        this.iConsumptionDialogRef.afterClosed().subscribe(() => {
            this.iConsumptionDialogRef = null!;
        });
        this.iConsumptionDialogRef.componentInstance.updateConsumption.subscribe(() => {
            if (this.account() != null) {
                this.generalService.getAccountConsumptionType(this.account()!).pipe(first()).subscribe((res: ConsumptionDataType) => {
                    // Because consumptionDataType is an input signal, we cannot directly assign a new value.
                    // Instead, we rely on the parent to update it via the input binding.
                    // The subscription in the dialog will notify the parent through the usual update mechanism.
                });
            }
            this.iConsumptionDialogRef = null!;
        });
        this.iConsumptionDialogRef.componentInstance.isForm = true;
        this.iConsumptionDialogRef.componentInstance.isAIBased = true;

        this.iConsumptionDialogRef.componentInstance.account = this.account()!;
    }

    hasConsumption(): boolean {
        const type = this.consumptionDataType();
        return type !== null && type === ConsumptionDataType.FULL;
    }
}